import { HiArrowLeft } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import EditProfileButtonSection from "./shared/EditProfileButtonSection";
import { RouteName } from "constant/routeNames";
import { useSelector } from "react-redux";

function EditProfileLeftSection() {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const navigate = useNavigate();

  return (
    <div className="flex w-full">
      {/* back arrow icon */}
      <button
        type="button"
        className="z-20 ml-4 mt-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-2xl text-black transition-colors hover:bg-white/90 max-sm:absolute max-sm:top-[50px]"
        onClick={() => {
          navigate(RouteName.UserProfile.replace("*", loggedInUser.username));
        }}
        aria-label="Back to profile"
      >
        <HiArrowLeft />
      </button>
      <div className="w-full flex-1 min-w-0">
        <EditProfileButtonSection />
      </div>
    </div>
  );
}

export default EditProfileLeftSection;